import { parseSectionSettings } from 'legacy/lut/features/partner360/configuration/helpers/parseSectionSettings'
import { createSelector } from 'reselect'

import type { ISobMandatoryContext } from 'partner360/features/financialPlanQuality'

import { selectCockpitPartnerData } from './selectCockpitPartnerData'

export const selectCockpitSobMandatoryContext = createSelector(
  selectCockpitPartnerData,
  (partners): ISobMandatoryContext => ({
    partnerFlags: partners[0]?.PartnerFlags ?? '',
    sectionSettings: parseSectionSettings(partners[0]?.SectionSettings ?? null),
  })
)
